/**
 * Tutorial guidato della pagina Piano social.
 *
 * Come il Blog: in alto le impostazioni del piano (con i template salvati), sotto
 * l'elenco dei post. Il tutorial apre il riquadro delle impostazioni per mostrarne
 * i campi, e `stopSocialTour` lo richiude - ma solo se a spalancarlo e' stato lui.
 */
const SCOPE = '[data-tour-scope="social"]';

const at = name => `${SCOPE} [data-tour="${name}"]`;

let opened = false;

const visible = selector => {
	const element = document.querySelector(selector);

	return !!element && element.getClientRects().length > 0;
};

/** Apre il riquadro delle impostazioni, se non e' gia' aperto. */
function openSettings() {
	if (visible(at('settings'))) return;

	const toggle = document.querySelector(at('expand'));

	if (toggle) {
		opened = true;
		toggle.click();
	}
}

/** Richiude il riquadro aperto dal tutorial. */
export function stopSocialTour() {
	if (!opened) return;

	opened = false;

	if (visible(at('settings'))) {
		document.querySelector(at('expand'))?.click();
	}
}

export function createSocialTourSteps() {
	return [
		{
			body: 'Qui si prepara il calendario dei post social del mese: ogni post mostra un prodotto con il suo prezzo, un titolo promozionale e la grafica del negozio. I post programmati escono da soli su Facebook e Instagram; per TikTok arriva l’immagine da caricare dall’app.',
			key: 'intro',
			placement: 'bottom',
			target: at('tutorial'),
			title: 'Il piano social',
		},
		{
			body: 'Impostazioni e template apre la configurazione: quanti post al mese, in che lingua, a che ore, su quali social e da dove pescare i prodotti. Dentro ci sono anche i template salvati.',
			before: stopSocialTour,
			key: 'expand',
			placement: 'right',
			target: at('expand'),
			timeout: 400,
			title: 'Aprire le impostazioni',
		},
		{
			body: 'Le fonti accese si alternano: più visti sul sito, più venduti, nuovi e in offerta, tutti degli ultimi 30 giorni. Un prodotto già pubblicato non torna prima dei giorni indicati, così il piano non ripete sempre gli stessi. Salva impostazioni registra la configurazione, non genera niente.',
			before: openSettings,
			key: 'sources',
			placement: 'top',
			target: at('sources'),
			timeout: 600,
			title: 'Da dove arrivano i prodotti',
		},
		{
			body: 'Un template è una grafica salvata: disposizione di logo, titolo e prezzo, colori e grandezze. Quello predefinito si applica a ogni post del piano; nei singoli post si può sempre cambiare.',
			before: openSettings,
			key: 'template-list',
			placement: 'top',
			target: at('template-list'),
			timeout: 400,
			title: 'I template',
		},
		{
			body: "Sceglie i prodotti per i giorni che restano del mese e fa scrivere all'IA un payoff per ognuno. Prima di partire chiede conferma; il lavoro gira in sottofondo e a fine corsa arriva una notifica.",
			before: stopSocialTour,
			key: 'generate',
			placement: 'left',
			target: at('generate'),
			title: 'Generare il piano del mese',
		},
		{
			body: 'Per aggiungere un post a mano, fuori dal piano: si sceglie il prodotto e il resto si compila come negli altri.',
			key: 'new',
			placement: 'left',
			target: at('new'),
			title: 'Un post in più',
		},
		{
			body: 'La ricerca filtra per prodotto o titolo (da tre caratteri), i chip degli stati restringono l’elenco. Ricerca, stato e pagina restano nell’indirizzo.',
			key: 'filters',
			placement: 'bottom',
			target: at('filters'),
			title: 'Cercare e filtrare',
		},
		{
			body: 'Ogni riga è un post: prodotto e titolo, da quale fonte arriva, i social (colorati quando è uscito, rossi se qualcosa non è andato) e quando si pubblica.',
			key: 'table',
			placement: 'top',
			target: at('table'),
			title: 'Leggere l’elenco',
		},
		{
			body: 'I tre pallini aprono le azioni del post: modificarlo, pubblicarlo subito, annullarlo, scaricare l’immagine di ogni social o eliminarlo. La scheda del post ha un tutorial suo.',
			key: 'row-menu',
			placement: 'right',
			target: at('row-menu'),
			title: 'Le azioni di un post',
		},
	];
}
